import isPlainObject from 'isobject';

function typescript(style) {
  for (var property in style) {
    var value = style[property];

    if (property === 'nested' && isPlainObject(value)) {
      Object.assign(style, typescript(value));
      delete style.nested;
    } else if (isPlainObject(value)) {
      typescript(value);
    }
  }

  return style;
}

export default (function () {
  return typescript;
});